<div class="app-input-wrapper">
  <div class="form-group">
    <label *ngIf="config.label" [for]="config.id" [class.required]="config.required">
      {{ config.label }} <span *ngIf="config.required" class="required">*</span>
    </label>
    <input
      [id]="config.id"
      class="form-control"
      [class.is-invalid]="hasErrors"
      [type]="config.type"
      [name]="config.name || config.id"
      [value]="value"
      [placeholder]="config.placeholder || ''"
      [required]="config.required"
      [disabled]="config.disabled || isDisabled"
      [appAutofocus]="config.autofocus"
      [attr.min]="config.min"
      [attr.max]="config.max"
      [attr.maxlength]="config.maxlength"
      (blur)="onBlur()"
      (input)="onChange($event)"
      (keydown.enter)="onEnter($event)"
    />
    <div *ngIf="hasErrors" class="invalid-feedback">
      {{ getApiError() || getValidatorError() }}
    </div>
  </div>
</div>
